// extracted by mini-css-extract-plugin
export default {"containerFAQSection":"FAQSection_containerFAQSection__kjlP4","FAQSection":"FAQSection_FAQSection__xbmmT","subtitle":"FAQSection_subtitle__MwTLr","text":"FAQSection_text__SlyJz"};